export default __webpack_public_path__ + "static/media/kabbikReads.37df0b66.jpg";